// export default (value) => {
//   if (isNaN(value) || value === null) return "0";
//   return Number(value).toLocaleString("en-US");
// };

//applies precision and delimiter to the number
//precision point is only applied if the number has a decimal point
export const formatNumber = (value, precision = 2) => {
  if (value === null || value === undefined || value === "") return "0";
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);

  const hasDecimal =
    (typeof value === "string" && value.includes(".")) || !Number.isInteger(n);

  const opts = hasDecimal
    ? { minimumFractionDigits: precision, maximumFractionDigits: precision, useGrouping: true }
    : { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true };

  return new Intl.NumberFormat("en-US", opts).format(n);
};